import styled from "styled-components";

const NoWrap = styled("span")({
    whiteSpace: "nowrap"
});

export default NoWrap;